import type { BlankPdf, Template } from "@pdfme/common";
import { PDFME_VERSION_PINNED } from "./version";

/** Page sizes offered for a new template, in mm. */
export const PAGE_SIZE_PRESETS: {
  key: "a4-portrait" | "a4-landscape" | "card";
  label: string;
  width: number;
  height: number;
}[] = [
  { key: "a4-portrait", label: "A4 pionowo", width: 210, height: 297 },
  { key: "a4-landscape", label: "A4 poziomo", width: 297, height: 210 },
  { key: "card", label: "Karta (85,6 × 54 mm)", width: 85.6, height: 54 },
];

/** A blank page; the padding is the margin that tables flowing onto further pages stay inside. */
export function blankBasePdf(widthMm: number, heightMm: number, paddingMm = 10): BlankPdf {
  return { width: widthMm, height: heightMm, padding: [paddingMm, paddingMm, paddingMm, paddingMm] };
}

export function createEmptyTemplate(widthMm: number, heightMm: number): Template {
  return { basePdf: blankBasePdf(widthMm, heightMm), schemas: [[]], pdfmeVersion: PDFME_VERSION_PINNED };
}
